import { SwitchClassNames } from './constants';
import { ActivePill, InactivePill, PillsContainer } from './Switch.styled';
import { SwitchElementSize } from './types';

export type PillsProps = {
  isColored: boolean;
  checked: boolean | undefined;
  dataOff: string | JSX.Element;
  dataOn: string | JSX.Element;
  elementSize: SwitchElementSize;
  disabled: boolean;
};

const SwitchPills: React.FC<PillsProps> = ({
  isColored,
  checked,
  dataOff,
  dataOn,
  elementSize,
  disabled,
}) => (
  <PillsContainer
    $elementSize={elementSize}
    className={SwitchClassNames.PillsContainer}
    disabled={disabled}>
    <InactivePill
      $elementSize={elementSize}
      className={SwitchClassNames.InactivePill}>
      {dataOn}
    </InactivePill>
    <InactivePill
      $elementSize={elementSize}
      className={SwitchClassNames.InactivePill}>
      {dataOff}
    </InactivePill>

    <ActivePill
      $elementSize={elementSize}
      $isChecked={checked}
      $isColored={isColored}
      className={SwitchClassNames.ActivePill}
      data-checked={checked}>
      {checked ? dataOff : dataOn}
    </ActivePill>
  </PillsContainer>
);

export default SwitchPills;
